/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-10-14 15:46:25
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-12-11 17:32:26
 * @FilePath: \mall\src\utils\svgIcon.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import svgIcon from '@/components/SvgIcon/index.vue' // 引入刚才新建的svg组件
import Vue from 'vue'
// 导入图标管理器
import iconManager from './iconManager'

Vue.component('svg-icon', svgIcon) // 全局组件

// 将图标管理器挂载到Vue原型上，方便在组件中使用
Vue.prototype.$iconManager = iconManager

// 保持原有的require.context导入方式以确保向后兼容
const req = require.context(
  '@/assets/icons',
  false,
  /\.svg$/
) // ./svg，就是我们放svg图标的文件名

const requireAll = requireContext =>
  requireContext.keys().map(requireContext)

// 但是我们不再立即执行requireAll(req)，而是让图标按需加载
// requireAll(req)